import React, { useState, useEffect } from 'react';
import { Container, Grow, Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import Form from './components/Form/Form';

const FromApp = () => {
  const [currentId, setCurrentId] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
  }, [currentId, dispatch]);

  return (
    <Container maxWidth="lg" >

      <Grow in>
        <Container>
        <Grid container   direction="column"
  alignItems="center"
  justify="center"
>            <Grid item xs={10} sm={8} md={8} spacing={1}
>
              <Form currentId={currentId} setCurrentId={setCurrentId} />
            </Grid>
          </Grid>
        </Container>
      </Grow>
    </Container>
  );
};

export default FromApp;
